import { ReactComponent as Icon } from '../../assets/icon.svg'

export const AppIcon = () => <Icon />
